import { render, staticRenderFns } from "./ItemSistemaUnidade.vue?vue&type=template&id=70e37d4b"
import script from "./ItemSistemaUnidade.vue?vue&type=script&lang=js"
export * from "./ItemSistemaUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports